// src/js/constants/action-types.js

export const ADD_ARTICLE = "ADD_ARTICLE";

export const FETCH_ANNOUNCEMENT = "FETCH_ANNOUNCEMENT";

export const FETCH_MAP = "FETCH_MAP";
export const GET_FONTSIZEENABLED = "fontSizeEnabled";

export const GET_COLOURBLINDENABLED = "colourBlindEnabled";
